// extracted by mini-css-extract-plugin
export default {"container":"HomeInnerLayout2_container__G3gAi"};